<template>
  <aside v-if="view" class="banner-invite-shopping">
    <div class="container">
      <div class="banner-invite-shopping__mobile">
        <div
          class="columns is-mobile is-vcentered covid has-text-centered is-centered"
        >
          <div class="column is-full">
            <p class="banner-invite-shopping__phrase has-text-grey-darker">
              Utilize seu saldo na versão beta do
              <span class="has-text-primarydark has-text-weight-bold"
                >Shopping Casar.com</span
              >
              e receba 4% da compra de volta!
              <a
                class="banner-invite-shopping__link has-text-grey-darker"
                target="_blank"
                @click="learnMore"
                >Saiba mais.</a
              >
            </p>
          </div>
        </div>
      </div>

      <div class="banner-invite-shopping__desktop">
        <div class="columns is-vcentered covid is-centered has-text-centered">
          <div class="column is-full is-inline-block">
            <p class="banner-invite-shopping__phrase has-text-grey-darker">
              Utilize seu saldo na versão beta do
              <span class="has-text-primarydark has-text-weight-bold"
                >Shopping Casar.com</span
              >
              e receba 4% da compra de volta!
              <a
                class="banner-invite-shopping__link has-text-grey-darker"
                target="_blank"
                @click="learnMore"
                >Saiba mais.</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      view: true,
    }
  },

  methods: {
    close() {
      this.view = false
    },
    learnMore() {
      this.$emit('showModal', true)
    },
  },
}
</script>

<style lang="scss">
.banner-invite-shopping {
  padding: 18px 4em;
  margin: 0 auto;
  background-color: #fdf2f6;
  height: auto;
  @media (min-width: $desktop) {
    padding: 21px 12px;
    height: 64px;
  }

  &__desktop {
    display: none;
  }

  @media (min-width: $tablet) {
    &__mobile {
      display: none;
    }

    &__desktop {
      display: block;
      margin: auto 0;
      top: 0;
      bottom: 0;
      max-width: inherit;
    }
  }

  &__phrase {
    font-size: 16px;

    @media (min-width: $tablet) {
      font-size: 1em;
    }
  }

  &__link {
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
